import { graphql } from '@predium/client-graphql';

graphql(`
  fragment PortfolioManagementPortfolio on portfolio {
    id
    has_write_permission
    name
    created_at
    updated_at
    __typename
    economic_units_with_buildings: economic_units(
      where: { buildings_aggregate: { count: { predicate: { _gt: 0 } } } }
    ) {
      buildings {
        id
      }
    }
  }
`);

export const GET_PORTFOLIOS = graphql(`
  query PortfolioManagementGetAllPortfolios {
    portfolio(order_by: { name: asc }) {
      ...PortfolioManagementPortfolio
    }
  }
`);

export const GET_PORTFOLIOS_WITH_WRITE_PERMISSIONS = graphql(`
  query PortfolioManagementGetAllPortfoliosWithWritePermissions($user_id: Int!) {
    portfolio(
      order_by: { name: asc }
      where: {
        _or: [
          { org: { users: { id: { _eq: $user_id }, role_id: { _eq: ORG_ADMIN } } } }
          { user_permissions: { _and: { write: { _eq: true }, user_id: { _eq: $user_id } } } }
        ]
      }
    ) {
      ...PortfolioManagementPortfolio
    }
  }
`);

export const GET_PORTFOLIO_OBJECTS_AGGREGATE = graphql(`
  query PortfolioObjectsAggregate($portfolioId: Int!) {
    building_aggregate(where: { economic_unit: { portfolio_id: { _eq: $portfolioId } } }) {
      aggregate {
        count
      }
    }

    report_aggregate(
      where: { report_buildings: { building: { economic_unit: { portfolio_id: { _eq: $portfolioId } } } } }
    ) {
      aggregate {
        count
      }
    }

    scenario_aggregate(where: { portfolio_id: { _eq: $portfolioId } }) {
      aggregate {
        count
      }
    }

    building_draft_aggregate(where: { portfolio_id: { _eq: $portfolioId } }) {
      aggregate {
        count
      }
    }

    economic_unit_aggregate(where: { portfolio_id: { _eq: $portfolioId } }) {
      aggregate {
        count
      }
    }

    active_action_plans_aggregate(where: { scenario: { portfolio_id: { _eq: $portfolioId } } }) {
      aggregate {
        count
      }
    }

    action_aggregate(
      where: { action_plan: { active_scenario: { scenario: { portfolio_id: { _eq: $portfolioId } } } } }
    ) {
      aggregate {
        count
      }
    }

    consumption_aggregate(where: { building: { economic_unit: { portfolio_id: { _eq: $portfolioId } } } }) {
      aggregate {
        count
      }
    }

    consumption_draft_aggregate(where: { building: { economic_unit: { portfolio_id: { _eq: $portfolioId } } } }) {
      aggregate {
        count
      }
    }
  }
`);

export const GET_PORTFOLIOS_AND_ECONOMIC_UNITS = graphql(`
  query GetPortfoliosAndEconomicUnits {
    portfolio(order_by: { name: asc }) {
      id
      has_write_permission
      name
      economic_units {
        id
        name
        responsible_user_id
      }
    }
  }
`);
